import React from 'react';
import './styles.css';

const Avatar = ({ text, size = 'md', src, className = '' }) => {
  // Calculer la taille précise en pixels
  const getSizeInPx = () => {
    switch(size) {
      case 'xs': return 24;
      case 'sm': return 32;
      case 'md': return 48;
      case 'lg': return 64;
      case 'xl': return 120;
      default: return 48;
    }
  };

  const sizeClass = `avatar-${size}`;
  
  // Ajouter une classe spéciale pour les avatars sans image (placeholder)
  const placeholderClass = !src ? 'avatar-placeholder' : '';

  // Style inline pour forcer la taille exacte
  const sizeInPx = getSizeInPx();
  const inlineStyle = {
    width: `${sizeInPx}px`,
    height: `${sizeInPx}px`,
    minWidth: `${sizeInPx}px`,
    minHeight: `${sizeInPx}px`,
    maxWidth: `${sizeInPx}px`,
    maxHeight: `${sizeInPx}px`
  };

  return (
    <div 
      className={`avatar ${sizeClass} ${placeholderClass} ${className}`}
      role="img"
      aria-label={text}
      style={inlineStyle}
    >
      {src ? (
        <img 
          src={src}
          alt={text}
          className="avatar-image"
          onError={(e) => {
            console.error('Error loading avatar:', e);
            e.target.style.display = 'none';
            // Ajouter la classe placeholder quand l'image échoue
            e.target.parentElement.classList.add('avatar-placeholder');
            e.target.parentElement.textContent = text;
          }}
        />
      ) : text}
    </div>
  );
};

export default Avatar; 